import { render, staticRenderFns } from "./TermsAndConditions.vue?vue&type=template&id=c7c0efec&scoped=true&"
import script from "./TermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c0efec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7c0efec')) {
      api.createRecord('c7c0efec', component.options)
    } else {
      api.reload('c7c0efec', component.options)
    }
    module.hot.accept("./TermsAndConditions.vue?vue&type=template&id=c7c0efec&scoped=true&", function () {
      api.rerender('c7c0efec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/TermsAndConditions.vue"
export default component.exports